import { Col } from 'antd'
import styled from 'styled-components'

const StyledPaddingTopCol = styled(Col)`
  padding-top: 40px;
`

export default StyledPaddingTopCol
